import { FileList, FileUploadFormik } from '@strata/react-file-upload';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

export const ProductPayerConfigFileUpload = ({
    required = true,
    onFileChange = undefined,
    inputRef = undefined,
    triggerOnly = false,
}) => {
    const formik = useFormikContext();

    const clearFile = () => {
        formik.setFieldValue('fileToUpload', undefined);
        formik.setFieldValue('productSegmentConfigFile', undefined);
        onFileChange?.();
    };

    const fileUpload = (
        <FileUploadFormik
            id="productSegmentConfigFile"
            label="Product Payer Config File"
            required={required}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            maxAllowedFiles={1}
            inputRef={inputRef}
            onAddFiles={(files) => {
                formik.setFieldValue('fileToUpload', files?.[0]);
                onFileChange?.();
            }}
            onRemoveFile={clearFile}
        />
    );

    if (triggerOnly) {
        return (
            <>
                <div style={{ display: 'none' }}>{fileUpload}</div>
                {formik.values.productSegmentConfigFile?.length > 0 && (
                    <FileList
                        files={formik.values.productSegmentConfigFile}
                        onRemoveFileClick={clearFile}
                    />
                )}
            </>
        );
    }

    return fileUpload;
};

ProductPayerConfigFileUpload.propTypes = {
    required: PropTypes.bool,
    onFileChange: PropTypes.func,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    triggerOnly: PropTypes.bool,
};
